export class IgnoreDirtyDirective implements angular.IDirective {
    public static $name: string = 'ignoreDirty';
    public restrict: string = 'A';
    public require: string = 'ngModel';

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        /* Angular only marks a form input as dirty if it was set to pristine at the time it was edited */
        ngModel.$pristine = false;

        /**
         * Calling $setPristine after this directive has been executed would break its functionality,
         * so we must disable it on this particular input
         */
        // tslint:disable-next-line: no-empty
        ngModel.$setPristine = () => { };
    }

    public static Factory() {
        let directive = () => {
            return new IgnoreDirtyDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
